export enum ProductTypes {
	PHYSICAL = 'physical',
	EVENT = 'event',
	COURSE = 'course',
	SOFTWARE = 'software',
	EBOOK = 'ebook',
	SUBSCRIPTION = 'subscription',
	OTHER = 'other',
}

export interface ProductProps {
	id: number;
	name: string;
	description: string;
	cover_picture: string;
	type: ProductTypes;
	soft_descriptor: string;
	support_email: string;
	support_phone: string;
	is_active: boolean;
}
